import { LoadableClassComponent } from "@loadable/component";

export interface StepEngine {
  // Object based on the StepEngineContext from the backend
  stepData: StepData;

  // Redirect to home page
  backToHome: boolean;

  // Redirect to login-error page
  goToLoginError: boolean;

  // Manage the modal
  showEligibilityModal: boolean;

  // Manage the error modal
  showErrorModal: boolean;

  // Store and refresh all user responses by Step id
  globalData: {
    [id: string]: any,
    damagedGoodSelection?: any,
    damagedGoodCreation?: any,
    damagedGoodFamily?: any,
    customerInformation?: any,
    concernedDamagedGood?: any,
    purchaseValue?: any,
    customerSpecifyProperty?: any,
    insuredGoods: InsuredGood[]
  };

  // Store all user responses by Step id
  declarationGlobalData: {
    [id: string]: any,
    damagedGoodSelection?: any,
    damagedGoodCreation?: any,
    damagedGoodFamily?: any,
    customerInformation?: any,
    concernedDamagedGood?: any,
    purchaseValue?: any,
    customerSpecifyProperty?: any,
    insuredGoods: InsuredGood[]
  };

  // Manage the Rating
  showRatingModal: boolean;

  // Store all steps with atributes like name, group, disablebutton etc ...
  stepList: StepList[];

  components: { [stepName: string]: LoadableClassComponent<any> };
}

export interface StepList {
  stepGroup: string,
  stepName: string,
  insuredGroupIndex: number,
  disableNextButton: boolean,
  component: any
}

export interface InsuredGood {
  concernedDamagedGood?: {
    id: string,
    label: string,
  },
  customerSpecifyProperty?: string,
  conditionOfProperty?: {
    code: string,
    value: string,
    label: string,
  },
  damagedGoodPurchaseDate?: string,
  purchaseValue?: string,
  methodOfPaymentConfirmation?: {
    code: string,
    value: string,
    label: string,
  },
  declareAnotherDamage?: {
    code: string,
    value: string,
    label: string,
  }
}

export interface StepData {
  currentSteps: string[];
  lastEditStep: string;
  receivedStep: string[];
  additionalStep: string;
  journeyData: JourneyData;
  subscriptionDto: any;
  createdClaimNumber: string;
  showStepAction: boolean;
  stepGroup: string;
  dontShowPopupRedirectUrl?: boolean;
  deviceType: string;
  currentStepGroup: string;
  lastRepeatableStepGroup: number;
  currentRepeatableStepGroup: number;
}

export interface JourneyData {
  customerEntry: { [id: string]: string };
  cover: string;
  coverDisplayName: string;
}

export const initialState: StepEngine = {
  stepData: {
    currentSteps: ['GET_FIRST_STEP'],
    lastEditStep: '',
    additionalStep: '',
    journeyData: {
      customerEntry: {
        CORDINATES_UPDATE: '0',
      },
      cover: null,
      coverDisplayName: '',
    },
    showStepAction: null,
    stepGroup: '',
    subscriptionDto: {},
    createdClaimNumber: '',
    dontShowPopupRedirectUrl: false,
    receivedStep: null,
    deviceType: null,
    currentStepGroup: "",
    lastRepeatableStepGroup: null,
    currentRepeatableStepGroup: null,
  },
  backToHome: false,
  goToLoginError: false,
  showEligibilityModal: false,
  showErrorModal: false,
  showRatingModal: false,
  globalData: {
    insuredGoods: [],
  },
  declarationGlobalData: {
    insuredGoods: [],
  },
  stepList: [{
    stepGroup: null,
    stepName: "GET_FIRST_STEP",
    disableNextButton: false,
    insuredGroupIndex: null,
    component: {}
  }],
  components: {}
};

export type StepEngineState = Readonly<StepEngine>;
